// extracted by mini-css-extract-plugin
module.exports = {"header":"water-regional_header__2J145","testMedia":"water-regional_testMedia__CPO_G"};